module.exports = __webpack_public_path__ + "assets/publication.1b079302.svg";